// extracted by mini-css-extract-plugin
export var divider = "_tv-0";
export var systemMessage = "_tv-1";